import BaseApiService from './api.base.service'

class ElearningApiService extends BaseApiService {
  constructor() {
    super('bom')
  }

  updateExpiries(data) {
    return this.callPost('elearning/update-dates', data)
  }

  sendToEduLife(data) {
    return this.callPost('elearning/send-to-edulife', data)
  }

  uploadAccreditationsElearning(data) {
    return this.callPost('elearning/add-characteristics', data)
  }
}
export const elearningApi = new ElearningApiService()
